import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["userSelect", "titleField", "descriptionField", "categoryField", "startDateField", "endDateField"]

  assignUser(event) {
    const select = event.target
    const activityId = select.dataset.activityId
    const selectedUserIds = Array.from(select.selectedOptions).map(option => option.value)

    this.updateActivity(activityId, { user_ids: selectedUserIds }, select)
  }

  updateField(event) {
    const field = event.target
    const activityId = field.dataset.activityId
    const fieldName = field.dataset.field
    const value = field.value

    this.updateActivity(activityId, { [fieldName]: value }, field)
  }

  updateActivity(activityId, data, element) {
    // Get CSRF token
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content

    // Send AJAX request to update activity using Turbo Streams
    fetch(`/activities/${activityId}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken,
        'Accept': 'text/vnd.turbo-stream.html'
      },
      body: JSON.stringify({
        activity: data
      })
    })
    .then(async response => {
      if (response.ok) {
        // Get the Turbo Stream response and render it
        const text = await response.text()
        if (text) {
          window.Turbo.renderStreamMessage(text)
        }
        this.showFeedback(element, 'success')
      } else {
        this.showFeedback(element, 'error')
        console.error('Failed to update activity')
      }
    })
    .catch(error => {
      this.showFeedback(element, 'error')
      console.error('Error updating activity:', error)
    })
  }

  showFeedback(element, type) {
    const originalBorder = element.style.border

    if (type === 'success') {
      element.style.border = '2px solid #85d56d'
    } else {
      element.style.border = '2px solid #e87171'
    }

    setTimeout(() => {
      element.style.border = originalBorder
    }, 1000)
  }
}
